import React from 'react';
import PropTypes from 'prop-types';

import {IconButton, Stack, Typography} from 'views/components';
import {Edit as EditIcon} from 'views/icons';
import {translate} from 'views/module';

import ClientNameEdit from './ClientNameEdit';

const ClientName = (props) => {
  const {clientData, setRefresh} = props;

  const [isEditing, setIsEditing] = React.useState(false);

  const clientName = clientData.clientName;
  const primaryRelationship = Object.values(clientData.relationships ?? {}).find((rel) => rel.name === clientName);
  const connectionType = primaryRelationship?.connectionType;

  const onSaved = () => {
    setIsEditing(false);
    setRefresh((value) => value + 1);
  };

  return (
    <>
      <Stack
        direction='row'
        spacing={1}
        sx={{
          alignItems: 'center',
          cursor: 'pointer',
        }}
        onClick={() => setIsEditing(true)}
      >
        <Typography sx={{fontSize: '28px', fontWeight: 400}}>
          {clientName}
          {
            connectionType &&
            ` (${connectionType})`
          }
        </Typography>
        <IconButton size='small' aria-label={translate('loomLead.LoomLeadDetail.Header.ChangeName.Title')}>
          <EditIcon fontSize='small' />
        </IconButton>
      </Stack>
      {
        isEditing &&
        <ClientNameEdit
          clientData={clientData}
          onClose={() => setIsEditing(false)}
          onSaved={onSaved}
        />
      }
    </>
  );
};

ClientName.propTypes = {
  clientData: PropTypes.object.isRequired,
  setRefresh: PropTypes.func.isRequired,
};

export default React.memo(ClientName);
